<ng-container *ngIf="hasValue">
    <ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>
</ng-container>

